/**
 * @author Leonel Martinez
 * @file All snackbar messages and configurations
 * @see Snackbar.vue
 */

import i18n from "@/i18n";

export const MESSAGES = {
  SERVER_ERROR: {
    icon: "cancel",
    iconColor: "white",
    color: "red",
    text: i18n.tc("ErrorMessages.ServerError"),
    multiline: false,
    timeout: 15000,
    x: "center",
    y: "top"
  },
  ERROR: {
    CATEGORIES_TREE: {
      icon: "cancel",
      iconColor: "white",
      color: "red",
      text: i18n.tc("ErrorMessages.CategoriesTree"),
      multiline: false,
      timeout: 15000,
      x: "center",
      y: "top"
    },
    YEARS: {
      icon: "cancel",
      iconColor: "white",
      color: "red",
      text: i18n.tc("ErrorMessages.Years"),
      multiline: false,
      timeout: 15000,
      x: "center",
      y: "top"
    },
    MAKES: {
      icon: "cancel",
      iconColor: "white",
      color: "red",
      text: i18n.tc("ErrorMessages.Makes"),
      multiline: false,
      timeout: 15000,
      x: "center",
      y: "top"
    },
    MODELS: {
      icon: "cancel",
      iconColor: "white",
      color: "red",
      text: i18n.tc("ErrorMessages.Makes"),
      multiline: false,
      timeout: 15000,
      x: "center",
      y: "top"
    },
    ENGINES: {
      icon: "cancel",
      iconColor: "white",
      color: "red",
      text: i18n.tc("ErrorMessages.Makes"),
      multiline: false,
      timeout: 15000,
      x: "center",
      y: "top"
    },
    VEHICLES: {
      icon: "cancel",
      iconColor: "white",
      color: "red",
      text: i18n.tc("ErrorMessages.Vehicles"),
      multiline: false,
      timeout: 15000,
      x: "center",
      y: "top"
    },
    CREATE_VEHICLE: {
      icon: "cancel",
      iconColor: "white",
      color: "red",
      text: i18n.tc("ErrorMessages.CreateVehicle"),
      multiline: false,
      timeout: 15000,
      x: "center",
      y: "top"
    },
    VEHICLEID: {
      icon: "cancel",
      iconColor: "white",
      color: "red",
      text: i18n.tc("ErrorMessages.VehicleID"),
      multiline: false,
      timeout: 15000,
      x: "center",
      y: "top"
    },
    INQUIRY: {
      icon: "cancel",
      iconColor: "white",
      color: "red",
      text: i18n.tc("ErrorMessages.Inquiry"),
      multiline: false,
      timeout: 15000,
      x: "center",
      y: "top"
    },
    C2C: {
      icon: "cancel",
      iconColor: "white",
      color: "red",
      text: i18n.tc("ErrorMessages.C2C"),
      multiline: false,
      timeout: 15000,
      x: "center",
      y: "top"
    },
    SEARCH_VEHICLE: {
      icon: "cancel",
      iconColor: "white",
      color: "red",
      text: i18n.tc("ErrorMessages.SearchVehicle"),
      multiline: false,
      timeout: 15000,
      x: "center",
      y: "top"
    },
    GET_PARTS: {
      icon: "cancel",
      iconColor: "white",
      color: "red",
      text: i18n.tc("ErrorMessages.GetParts"),
      multiline: false,
      timeout: 15000,
      x: "center",
      y: "top"
    },
  },
  NO_PARTS_FOUND: {
    icon: "error",
    iconColor: "black",
    color: "warning black--text",
    text: i18n.tc("Snackbar.NoPartsFound"),
    multiline: false,
    timeout: 15000,
    x: "center",
    y: "top"
  },
  NO_ORDER_FOUND: {
    color: "red",
    icon: "cancel",
    iconColor: "white",
    text: i18n.tc("Snackbar.NoOrderFound"),
    timeout: 15000,
    multiline: false,
    x: "center",
    y: "top"
  },
  VEHICLE_SELECTED: {
    icon: "directions_car",
    iconColor: "white",
    color: "orange",
    text: i18n.tc("Snackbar.VehicleSelected"),
    timeout: 1500,
    x: "right",
    y: "bottom"
  },
  VEHICLE_CREATED: {
    icon: "directions_car",
    iconColor: "white",
    color: "orange",
    text: i18n.tc("Snackbar.VehicleCreated"),
    timeout: 3000,
    x: "right",
    y: "bottom"
  },
  VEHICLE_UPDATED: {
    icon: "directions_car",
    iconColor: "white",
    color: "orange",
    text: i18n.tc("Snackbar.VehicleUpdated"),
    timeout: 1500,
    x: "right",
    y: "bottom"
  },
  VEHICLE_REQUIRED: {
    icon: "directions_car",
    iconColor: "black",
    color: "warning black--text",
    text: i18n.tc("Snackbar.VehicleRequired"),
    timeout: 2500,
    x: "center",
    y: "top"
  },
  VEHICLE_DIRTY: {
    icon: "cancel",
    iconColor: "white",
    color: "red",
    text: i18n.tc("Snackbar.VehicleDirty"),
    multiline: false,
    timeout: 5000,
    x: "center",
    y: "top"
  },
  CATALOG_REQUIRED: {
    icon: "directions_car",
    iconColor: "black",
    color: "warning black--text",
    text: i18n.tc("Snackbar.VehicleRequiredProduct"),
    timeout: 2000,
    x: "right",
    y: "bottom"
  },
  ADDED_TO_CART: {
    icon: "done",
    iconColor: "white",
    color: "primary",
    text: i18n.tc("Snackbar.AddedToCart"),
    timeout: 2000,
    x: "right",
    y: "bottom"
  },
  REMOVED_FROM_CART: {
    icon: "delete",
    iconColor: "white",
    color: "red",
    text: i18n.tc("Snackbar.RemovedFromCart"),
    timeout: 2000,
    x: "right",
    y: "bottom"
  },
  EMPTY_INTERCHANGE: {
    iconColor: "black",
    color: "warning dark black--text",
    text: i18n.tc("Snackbar.EmptyInterchange"),
    multiline: true,
    timeout: 15000,
    x: "center",
    y: "top"
  },
  EXCEL_IMPORTED: {
    icon: "attach_file",
    iconColor: "white",
    color: "primary",
    text: i18n.tc("Snackbar.ImportSuccess"),
    timeout: 3000,
    x: "right",
    y: "bottom"
  },
  CART_LOADED: {
    icon: "receipt",
    iconColor: "white",
    color: "primary",
    text: i18n.tc("Snackbar.CartLoaded"),
    timeout: 3000,
    x: "right",
    y: "bottom"
  },
  ORDER_SUCCESS: {
    icon: "done",
    iconColor: "white",
    color: "primary",
    text: i18n.tc("Snackbar.OrderCreated"),
    timeout: 2000,
    x: "right",
    y: "bottom"
  },
  CART_EMPTY: {
    icon: "error",
    iconColor: "white",
    color: "warning black--text",
    text: i18n.tc("Snackbar.CartEmpty"),
    timeout: 5000,
    x: "center",
    y: "top"
  },
  SUCCESS_EMAIL: {
    icon: "done",
    iconColor: "black",
    color: "green white--text",
    text: i18n.tc("ContactForm.successEmail"),
    timeout: 5000,
    x: "center",
    y: "top",
  },
  FAILED_EMAIL: {
    icon: "error",
    iconColor: "white",
    color: "red white--text",
    text: i18n.tc("ContactForm.failedEmail"),
    timeout: 5000,
    x: "center",
    y: "top",
  },
  PLATE_NOT_FOUND: {
    icon: "error",
    iconColor: "black",
    color: "warning black--text",
    text: i18n.tc("Snackbar.PlateNotFound"),
    timeout: 5000,
    x: "center",
    y: "top"
  },
  WILDCARD_SEARCH_ERROR: {
    icon: "cancel",
    iconColor: "white",
    color: "red",
    text: i18n.tc("Interchange.Messages.WildCardError"),
    multiline: false,
    timeout: 15000,
    x: "center",
    y: "top"
  },
  BUYER_NOT_FOUND: {
    icon: "error",
    iconColor: "white",
    color: "warning black--text",
    text: i18n.tc("Snackbar.BuyerNotFound"),
    multiline: false,
    timeout: 2000,
    x: "center",
    y: "top"
  },
  UNIQUE_DESCRIPTION_ERROR: {
    icon: "cancel",
    iconColor: "white",
    color: "red",
    text: i18n.tc("ErrorMessages.UniqueDescriptionError"),
    multiline: false,
    timeout: 15000,
    x: "center",
    y: "top"
  },
}
